import { useUnleashContext } from "@unleash/proxy-client-react";
import * as React from "react";
import { useEffect } from "react";

import { useCustomerCmId } from "Store/userIdentification/userIdentificationHooks";

export const UnleashContextWrapper = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement => {
  useUpdateUnleashContext();
  return <>{children}</>;
};

const useUpdateUnleashContext = (): void => {
  const customerCmId = useCustomerCmId();
  const updateContext = useUnleashContext();

  useEffect(() => {
    if (customerCmId) {
      updateContext({
        properties: {
          cmId: customerCmId,
        },
      });
    }
  }, [customerCmId]);
};
